import { LoginResponseDto } from "@/data/dto/login-response-dto";
import { LoginRequestPayload } from "@/data/payload/login-request-payload";
import { LoginSource } from "@/data/source/login-source";
import { LoginRepository } from "@/domain/repository/login-repository";
import { AES_KEY } from "@/utils/global-constants";
import { SATError, SATResult } from "@sadtx/sat-error";
import SecureStorageService from "@sadtx/secure-storage";
import { LoginResponseInfoMapper } from "@/data/mapper/login-response-info-mapper";
import { safeMapToEntity } from "./safe-map-to-entity";

export class LoginRepositoryImpl implements LoginRepository {
  loginSource: LoginSource;

  constructor(
    loginSource: LoginSource,
    private readonly secureStorage: SecureStorageService,
  ) {
    this.loginSource = loginSource;
  }

  async login(payload: LoginRequestPayload): Promise<SATResult<LoginResponseDto, SATError>> {
    const result = await this.loginSource.login(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      LoginResponseInfoMapper.toEntity,
      "LoginRepositoryImpl::login"
    );
  }

  async logout(): Promise<SATResult<void, SATError>> {
    const result = await this.loginSource.logout();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async clearSecureSession(): Promise<void> {
    await this.secureStorage.removeItem(sessionStorage, AES_KEY);
  }
}
